/**
 * Ayuda para instalar PWA cuando el navegador no dispara beforeinstallprompt
 * (Safari iOS, Firefox, ya instalada parcialmente, etc.).
 */
import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from 'react-i18next'
import { UDV_SURFACE, udvDialogProps } from './udvSurface'

/**
 * @param {{ open: boolean, onClose: () => void }} props
 */
function InstallPwaHelpDlg({ open, onClose }) {
  const { t } = useTranslation()
  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="xs" {...udvDialogProps}>
      <DialogTitle style={UDV_SURFACE.title}>{t('pwa.installTitle')}</DialogTitle>
      <DialogContent style={UDV_SURFACE.content}>
        <Typography variant="body2" paragraph style={{ color: 'inherit' }}>
          {t('pwa.installIntro')}
        </Typography>
        <Typography variant="body2" paragraph style={{ color: 'inherit' }}>
          <strong>Android / Chrome:</strong> {t('pwa.installAndroid')}
        </Typography>
        <Typography variant="body2" paragraph style={{ color: 'inherit' }}>
          <strong>iPhone / iPad:</strong> {t('pwa.installIos')}
        </Typography>
        <Typography variant="body2" style={UDV_SURFACE.muted}>
          {t('pwa.installDesktop')}
        </Typography>
      </DialogContent>
      <DialogActions style={UDV_SURFACE.actions}>
        <Button onClick={onClose} style={UDV_SURFACE.btnGhost}>
          {t('common.close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default InstallPwaHelpDlg
